import { useEffect, useRef, useState } from 'react'
import { MicrophoneMonitorStatus, startMicrophoneMonitor } from './audio/microphoneMonitor'

/** Samples live amplitude without rerendering the chat on every audio frame. */
export function useMicrophoneLevel(active: boolean) {
  const level = useRef(0)
  const [status, setStatus] = useState<MicrophoneMonitorStatus>('idle')

  useEffect(() => {
    level.current = 0
    if (!active) {
      setStatus('idle')
      return
    }
    const stop = startMicrophoneMonitor({
      onLevel: (value) => {
        level.current = value
      },
      onStatus: setStatus,
    })
    return () => {
      stop()
      level.current = 0
    }
  }, [active])

  return { level, status: active ? status : ('idle' as MicrophoneMonitorStatus) }
}
